import Head from 'next/head'

export default function Blog() {
  return (
    <>
      <Head>
        <title>privauto | Blog</title>
        {/*
         <script src='https://io.dropinblog.com/js/embed.js'></script>
        <script>var dib_id = '7H8CPZ5CYJEGVWU2ZJLT';</script> */}
      </Head>

      <div className='container'>
        <main className='content'>
          <div id='dib-posts'></div>
        </main>
      </div>

      <style jsx>{`
        :global(a.dib-pagination-prev, a.dib-pagination-next) {
          width: 14rem;
          padding: 10px 0;
          height: 4.2rem;
          border-radius: 2.1rem;
          font-size: 1.8rem;
          background: var(--primary-button-bg);
          transition: opacity 0.2s;
          color: var(--primary-button-color);
          font-weight: 700;
          text-align: center;
        }

        .container {
          max-width: 193rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        @media (max-width: 1024px) {
          .container {
            max-width: 100%;
            padding: 0 1.1rem 2rem;
          }
          .content {
            .big {
              margin: 2rem 0 0;
            }

            .small {
              margin: 1.6rem 0 0;
            }
          }
        }
      `}</style>
    </>
  )
}

Blog.getInitialProps = () => ({
  namespacesRequired: ['common'],
})
